module.exports = "<svg xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 400 400\"><title>Property CMS copy 3</title></svg>";